import styled, { css, DefaultTheme } from "styled-components";
import { theme } from "../../constants/StyledComponents";

type StyledCaptionsTypProps = {
  $variant?: string;
  $color?: string;
};

/* variants */

const variantStyles = (theme: DefaultTheme, variant = "1") =>
  ({
    1: css`
      font-size: ${theme.variables.fs_12};
    `,
  })[variant];

const StyledCaptionsTyp = styled.span<StyledCaptionsTypProps>`
  ${({ theme, $variant: variant }) => variantStyles(theme, variant)}
  color: ${({ $color: color }) => color ?? theme.colors.black};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export { StyledCaptionsTyp };
